<template>
  <div class="home">
    <div class="online_course_header_container">
      <div class="online_course_header_wrapper">
        <div class="online_course_header_text">
          <div class="header_text_2">Start learning your <strong>favorite topic today </strong></div>
          <div
            class="header_text_3"
          >With real professionals instructing you in the courses, we’ve got you covered.</div>
          <div class="button_wrapper">
            <button class="button button_md button_blue" @click="$router.push('/allcourse/?page=1'), $bus.emit('loading-toggle')">View All Courses</button>
          </div>
        </div>
        <div class="online_course_header_image">
          <!-- <div class="header_image">
            <img src="@/assets/images/header_image.png" />
          </div> -->
            <div class="header_image_container">
              <div class="header-group-1">
                <img src="@/assets/images/group-1.png" />
              </div>
              <div class="header-main-image">
                <img src="@/assets/images/landing_header_image.jpg" />
              </div>
              <div class="header-group-2">
                <i class="icon-zigzag-line"></i>
              </div>
            </div>
        </div>
      </div>
    </div>
    <div class="online_course_main">
      <div class="online_course_main_wrapper">
        <div class="student_trust_container">
          <div class="student_trust_wrapper container">
            <div class="student_trust_heading">Why Students <span>Trust Us</span></div>
            <div class="student_trust_content_container">
              <div class="student_trust_content_left">
                <div class="trust_content content_left_first">
                  <button type="button" class="trust_orange_button">
                    <v-icon>
                      mdi-star
                    </v-icon>
                    <span>
                    Experienced Team
                    </span>
                  </button>
                </div>
                <div class="trust_content content_left_second">
                  <button type="button" class="trust_purple_button">
                  <v-icon>
                      mdi-school
                    </v-icon>
                    <span>
                  Real Professionals
                    </span>
                  </button>
                </div>
                <div class="trust_content content_left_third">
                  <button type="button" class="trust_orange_button">
                  <v-icon>
                      mdi-check-circle
                    </v-icon>
                    <span>
                  24*7 Availability
                    </span>
                  </button>
                </div>
              </div>
              <div class="student_trust_image">
                <img src="@/assets/images/trust-shield.png" />
              </div>
              <div class="student_trust_content_right">
                <div class="trust_content content_right_first">
                  <button type="button" class="trust_orange_button">
                  <v-icon>
                      mdi-emoticon-happy
                    </v-icon>
                    <span>
                  Easy Interface
                    </span>
                  </button>
                </div>
                <div class="trust_content content_right_second">
                  <button type="button" class="trust_purple_button">
                  <v-icon>
                      mdi-shape
                    </v-icon>
                    <span>
                  Categorical Courses
                    </span>
                  </button>
                </div>
                <div class="trust_content content_right_third">
                  <button type="button" class="trust_orange_button">
                  <v-icon>
                      mdi-account-cash
                    </v-icon>
                    <span>
                  Easy Pay
                    </span>
                  </button>
                </div>
              </div>
            </div>
            <div class="content_middle">
                <button type="button" class="trust_purple_button">
                <v-icon>
                    mdi-book-multiple
                  </v-icon>
                  <span>
                Practical Courses
                  </span>
                </button>
              </div>
          </div>
        </div>
        <div class="featured_courses">
          <div class="container">
            <div class="featured_courses_wrapper">
              <v-row>
                <v-col cols="12" sm="6" md="4" >
                  <article class="featured_courses__heading-content">
                    <h2 class="featured_courses__title">Featured <span>Courses</span></h2>
                    <button class="button button_md button_blue" @click="$router.push('/allcourse'), $bus.emit('loading-toggle'), feature()">View All Courses</button>
                    <span class="icon-zigzag-line-alt-ex"></span>
                  </article>
                </v-col>

                <v-col cols="12" sm="6" md="4" v-for="(course,i) in courses" :key="i">
                  <div class="featured_courses_card_wrapper">
                    <CourseCard :course="course"></CourseCard>
          
                  </div>
                </v-col>
              </v-row>
            </div>
          </div>
        </div>
        
        <!-- <div class="students_say testimonial">
          <div class="container">
            <div class="students_say_wrapper">
              <VueSlickCarousel v-bind="settings" class="students_say_slider">
                <div class="testimonial__item d-flex justify-space-between align-end">
                  <blockquote class="text-right">
                    <span class="quote-in">"</span>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum.</p>
                    <cite>
                      <strong>Jane Fraser</strong>
                      <span>Co-founder at Infosys Institue of Computer</span>
                    </cite>
                  </blockquote>

                  <div class="media-group">
                    <div class="media-group__1">
                      <img src="@/assets/images/group-1.png" />
                    </div>
                    <div class="media-group__img">
                      <img src="@/assets/images/jane-fraser.png" />
                    </div>
                    <div class="media-group__2">
                      <i class="icon-zigzag-line"></i>
                    </div>
                  </div>
                </div>
                <div class="testimonial__item d-flex justify-space-between align-end">
                  <blockquote class="text-right">
                    <span class="quote-in">"</span>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum.</p>
                    <cite>
                      <strong>John Fraser</strong>
                      <span>Co-founder at Infosys Institue of Computer</span>
                    </cite>
                  </blockquote>

                  <div class="media-group">
                    <div class="media-group__1">
                      <img src="@/assets/images/group-1.png" />
                    </div>
                    <div class="media-group__img">
                      <img src="@/assets/images/landing_header_image.jpg" />
                    </div>
                    <div class="media-group__2">
                      <i class="icon-zigzag-line"></i>
                    </div>
                  </div>
                </div>
                <div class="testimonial__item d-flex justify-space-between align-end">
                  <blockquote class="text-right">
                    <span class="quote-in">"</span>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum.</p>
                    <cite>
                      <strong>Jane Fraser</strong>
                      <span>Co-founder at Infosys Institue of Computer</span>
                    </cite>
                  </blockquote>

                  <div class="media-group">
                    <div class="media-group__1">
                      <img src="@/assets/images/group-1.png" />
                    </div>
                    <div class="media-group__img">
                      <img src="@/assets/images/jane-fraser.png" />
                    </div>
                    <div class="media-group__2">
                      <i class="icon-zigzag-line"></i>
                    </div>
                  </div>
                </div>
                <div class="testimonial__item d-flex justify-space-between align-end">
                  <blockquote class="text-right">
                    <span class="quote-in">"</span>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum.</p>
                    <cite>
                      <strong>John Fraser</strong>
                      <span>Co-founder at Infosys Institue of Computer</span>
                    </cite>
                  </blockquote>

                  <div class="media-group">
                    <div class="media-group__1">
                      <img src="@/assets/images/group-1.png" />
                    </div>
                    <div class="media-group__img">
                      <img src="@/assets/images/landing_header_image.jpg" />
                    </div>
                    <div class="media-group__2">
                      <i class="icon-zigzag-line"></i>
                    </div>
                  </div>
                </div>
              </VueSlickCarousel>
            </div>
          </div>
        </div> -->

         <div class="featured_courses">
          <div class="container">
            <div class="featured_courses_wrapper">
              <v-row>
                <v-col cols="12" sm="6" md="4" >
                  <article class="featured_courses__heading-content">
                    <h2 class="featured_courses__title">Our <span>Teachers</span></h2>
                    <button class="button button_md button_blue" @click="$router.push('/lecturer'), $bus.emit('loading-toggle'), feature()">View All Teacher</button>
                    <span class="icon-zigzag-line-alt-ex"></span>
                  </article>
                </v-col>

                <template v-if="teacherlist">
                  <v-col cols="12" sm="6" md="4" v-for="(course,i) in teacherlist" :key="i" v-if="i <= 4">
                      <div class="featured_courses_card_wrapper">
                        <lecturer :course="course"></lecturer>
                      </div>
                  </v-col>
                </template>
                <template v-else>
                  <v-col cols="12" sm="6" md="4" v-for="(course,i) in teacher" :key="i" v-if="i <= 4">
                      <div class="featured_courses_card_wrapper">
                        <lecturer :course="course"></lecturer>
                      </div>
                  </v-col>
                </template>
              </v-row>
            </div>
          </div>
        </div>
        
        <div class="video-banner sajilo-section text-center">
          <div class="container">
            <div class="video-banner__title">Give us a try <strong>Never Look Back</strong></div>
            <div class="video-banner__video video-wrapper">
              <figure class="video-banner__video-thumb">
                <img src="@/assets/images/give-try-video.jpg">
              </figure>
              <button><v-icon>mdi-play</v-icon></button>
            </div>
            <span class="icon-zigzag-line"></span>
          </div>
        </div>

        <KeepLearning></KeepLearning>

        <!-- <div class="subscribe sajilo-section bottom-arrow-presentation arrow-right">
          <span class="icon-arrow-left-group"></span>
          <div class="container">
            <article class="subscribe__headarticle">
              <div class="subscribe__title sajilo-section__title">
                Subscribe to our <strong>Newsletter</strong>
              </div>
            </article>
            <form class="sajilo-form" action="">
              <div class="sajilo-form-group sajilo-form-inline">
                <input type="email" class="sajilo-form-input" placeholder="Enter your email address and subscribe">
                <button type="button" class="sajilo-form-button">
                  <v-icon>
                    mdi-chevron-right
                  </v-icon>
                </button>
              </div>
            </form>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import CourseCard from '@/components/Courses/CourseCard.vue'
import lecturer from '@/components/Courses/Lecturer.vue'
import KeepLearning from '@/components/KeepLearning/KeepLearning.vue'
// import {mapGetters} from 'vuex'
export default {
  name:'home',
  data () {
    return {
      settings: {
        dots: true,
        arrows: false,
        focusOnSelect: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        touchThreshold: 5,
        autoplay: true,
        fade: true,
        cssEase: 'linear',
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
              dots: true
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              initialSlide: 1
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      },
      courses: {
      },
      teacher: [
        {
          first_name: 'John',
          last_name: 'Doe',
          email: 'test@rest.com'
        },
        {
          first_name: 'John',
          last_name: 'Doe',
          email: 'test@rest.com'
        },
        {
          first_name: 'John',
          last_name: 'Doe',
          email: 'test@rest.com'
        },
        {
          first_name: 'John',
          last_name: 'Doe',
          email: 'test@rest.com'
        },
        {
          first_name: 'John',
          last_name: 'Doe',
          email: 'test@rest.com'
        },
      ],
      teacherlist: null,
    }
  },
  components: { 
    VueSlickCarousel,
    CourseCard,
    lecturer,
    KeepLearning
  },
  filters: {
      truncate: function (text, length, suffix) {
          if (text.length > length) {
              return text.substring(0, length) + suffix;
          } else {
              return text;
          }
      },
  },
  
  created () { 
      this.$store.dispatch('getFeatureCourses').then(res => {
        this.$bus.emit('loading-toggle')
        let courselist = res.results;
        for(let i =0; i <= 5; i++) {
          if(courselist[i]) {
            this.getCourses(courselist);
          }
        }
      })
  },

  mounted () {
    this.getLecture();
  },

  methods: {
    getCourses(course) {
      this.courses = course;
      this.$bus.emit('loading-toggle')
    },
    async getLecture() {
      await this.$api.get(`authuser/lecturer-list/`).then(res => {
        this.teacherlist = res.results;
      })
    },
    feature() {
      window.location.reload();
        window.scrollTo(0,0);
    }
  },

  // computed: {
  //   ...mapGetters({
  //     getLecturer: 'lecturer',
  //   }),
  // },
  
}
</script>

<style>
/* Header part */
.online_course_header_wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5rem 0;
}
.online_course_header_text {
  padding: 0 36px;
  margin-top: 20px;
}
.header_text_2 {
  font-size: 48px;
  margin-bottom: 12px;
  line-height: 1.2;
  font-weight: 400;
}
.header_text_2 strong {
  color: var(--color-red);
}
.header_text_3 {
  font-size: 20px;
  max-width: 550px;
  font-family: var(--font-poppins);
  color: var(--color-dark);
}
.button_wrapper {
  margin-top: 25px;
  font-family: var(--font-poppins);
}
.online_course_header_image {
  width: 100%;
  height: 447px;
}

.header_image_container {
  position: relative;
  height: 100%;
}
.header-group-1 {
  position: absolute;
  top: 0;
  right: 12%;
  z-index: 1;
}
.header-main-image {
  position: absolute;
  left: 18.5%;
  bottom: 0;
  height: 385px;
  width: 465px;
  z-index: 2;
}
.header-main-image img {
  height: 100%;
  width: 100%;
  object-fit: cover;
}
.header-group-2 {
  position: absolute;
  bottom: -11%;
  left: 8%;
  z-index: 3;
}
.header-group-2 > * {
  font-size: 5.625rem;
  color: var(--color-primary);
}
@media (min-width: 1904px) {
  .online_course_header_wrapper {
    max-width: 1785px;
    margin: auto;
  }
}
@media (max-width: 768px) {
  .online_course_header_image {
    display: none;
  }
  .header_text_2 {
    font-size: 36px;
  }
}

/* Why student trust */
.online_course_main {
  padding-top: 8rem;
}
.student_trust_container {
  background-color: rgb(14,161,223,0.03);
}
.student_trust_wrapper {
  padding: 4.5rem 0;
}
.student_trust_content_container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 36px;
  font-family: "Lora", serif;
}
.student_trust_text {
  max-width: 600px;
}
.student_trust_title {
  font-size: 36px;
  font-weight: 600;
  color: #4f4e4e;
}
.student_trust_heading {
  text-align: center;
  font-size: 36px;
  font-weight: 400;
  font-family: var(--font-poppins);
  margin-bottom: 98px;
}
.student_trust_heading span {
  color: var(--color-red);
  font-family: var(--font-lora);
  font-weight: 700;
}
.trust_orange_button {
  background: #efefef;
  border-radius: 3px;
}
.trust_orange_button i {
  background: var(--color-pink);
  color: #fff !important;
  padding: 5px;
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
}
.trust_purple_button {
  background: #efefef;
  border-radius: 3px;
}
.trust_purple_button i {
  background: var(--color-primary);
  color: #fff !important;
  padding: 5px;
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
}
.trust_orange_button span, .trust_purple_button span{
  padding: 0 16px;
  font-size: 14px;
  color: #181818;
}
.trust_content {
  padding-top: 4rem;
}
.student_trust_content_left {
  width: 100%;
}
.student_trust_image {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 50px;
}
.student_trust_content_right {
  width: 100%;
}
.content_left_first, .content_left_third {
  text-align: right;
}
.content_left_second {
  text-align: center;
}
.content_right_second {
  text-align: center;
}
.student_trust_image img {
  width: 230px;
  height: 100%;
}
.content_middle {
  text-align: center;
}
@media screen and (max-width: 768px) {
  .student_trust_image {
    display: none;
  }
  .student_trust_text {
    text-align: center;
  }
  .student_trust_title {
    font-size: 28px;
  }
}

/*Featured Courses */
.fatured_courses .container {
  padding-top: 0;
  padding-bottom: 0;
}
.featured_courses_wrapper {
  padding: 5.6rem 0;
}
.featured_courses_card {
  /* background: #efefef !important; */
}


/* Explore course*/
.explore_courses_wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}
.explore_courses_card:not(:last-child) {
  padding-right: 16px;
}
.explore_courses_heading {
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  font-size: 24px;
  padding-bottom: 20px;
  font-family: "Lora", serif;
}
.android_img {
  padding: 0 16px;
  margin-bottom: 16px;
}
.android_img img {
  background-color: #fff;
  border: 3px solid var(--color-primary);
  padding: 5px 10px;
  border-radius: 10px;
  margin-top: -30px;
  z-index: 999;
  position: absolute;
}
.courses_price_wrapper {
  position: relative;
}
.courses_price_wrapper > * {
  background-color: var(--color-red);
  color: var(--color-white);
  font-weight: 700;
  border: none;
  width: 90px;
  height: 90px;
  text-align: center;
  font-size: 24px;
  line-height: 1.4;
  padding-top: 5px;
  /* padding: 5px 10px; */
  border-radius: 100%;
  z-index: 999;
  position: absolute;
  margin-top: -10%;
  right: 18px;
  font-family: var(--font-lora);
}
.v-card {
  font-family: var(--font-poppins);
}
.card-meta-info {
  padding: 10px 16px;
  line-height: 1.5;
  color: var(--color-dark);
}
.card-meta-info .date {
  font-size: 12px;
  margin-bottom: 6px;
}
.card-meta-info .instructor-name {
  font-size: 14px;
  margin-bottom: 8px;
}
.card-meta-info + .v-card__title {
  padding: 0 16px;
  margin-bottom: 15px;
}
.card-purchase-count {
  padding: 0 16px;
  font-size: 14px;
  font-weight: 400;
}
.best_selling_btn {
  padding: 0 16px;
}
.card_info_rating {
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #807c7c;
}
.card-actions {
  padding: 16px;
}
.view_course_btn {
  padding: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.explore_online_courses {
  border-bottom: 2px solid #efefef;
}
@media screen and (max-width: 768px) {
  .explore_courses_wrapper {
    flex-direction: column;
  }
  .explore_courses_card:not(:last-child) {
    padding-bottom: 2rem;
    padding-right: 0;
  }
}

/* What students say */
.students_say_heading {
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  font-size: 24px;
  padding: 20px;
  font-family: "Lora", serif;
}
.students_say {
  padding-bottom: 3rem;
}
.student_img {
  display: flex;
  justify-content: center;
  align-items: center;
}
.student_img img {
  border-radius: 50%;
  height: 150px;
  width: 150px;
}
.students_say_slider .slick-list .slick-track .slick-slide {
  padding: 1rem;
}
.students_say_slider .slick-prev:before,
.slick-next:before {
  color: #222 !important;
}
.stds_say_title {
  justify-content: center;
}
.stds_say_subtitle {
  text-align: center;
}
.students_say_card {
  padding: 1rem;
}
@media screen and (max-width: 768px) {
  .students_say_slider .slick-list {
    text-align: center;
  }
  .students_say_slider .slick-list .slick-track .slick-slide {
    padding: 0.5rem;
  }
  .slick-prev {
    left: 0;
  }
  .slick-next {
    right: 0;
  }
}

/* Goals Part */
.goals_container {
  background-color: #fcf4cf;
}
.goals_content_container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 36px;
}
.goals_text {
  max-width: 450px;
}
.goals_title {
  font-size: 24px;
  font-family: "Lora", serif;
}
.goals_content {
  padding: 1rem 0;
  font-family: "Lora", serif;
}
@media screen and (max-width: 768px) {
  .goals_image {
    display: none;
  }
}

/* Learning Statistics Part */
.learning_statistics_content_container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.learning_statistics_text {
  max-width: 450px;
}
.learning_statistics_content {
  padding: 1rem 0;
  font-size: 24px;
  font-family: "Lora", serif;
}
.learning_statistics_image {
  position: relative;
}
.learning_statistics_image_text {
  position: absolute;
  max-width: 350px;
  top: 35%;
  left: 0%;
  padding: 1rem 3rem;
  font-size: 24px;
  color: #3473ef;
  background: #ffffffeb !important;
  font-family: "Lora", serif;
}
@media screen and (max-width: 768px) {
  .learning_statistics_content_container {
    flex-direction: column;
  }
  .learning_statistics_text {
    text-align: center;
  }
}
</style>
